import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion"

const WhatWeDo = () => {
  return (
    <>
      <div className="what-we-do-area ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div 
                className="what-we-do-content"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="100"
              >
                <span className="sub-title">What We Do</span>
                <h2>Chúng tôi sẽ làm gì để hỗ trợ doanh nghiệp</h2>
                <p>
                APCV có đội ngũ chuyên gia tư vấn, cam kết hỗ trợ doanh nghiệp của bạn trong hành trình số hóa. 
                Sử dụng thị giác máy tính, chúng tôi không chỉ giúp cải thiện hiệu suất mà còn mở ra những cơ hội sáng tạo 
                và tối ưu hóa quy trình kinh doanh của bạn. 
                </p>

                
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div 
                className="what-we-do-content-accordion"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="300"
              >
                <Accordion allowZeroExpanded preExpanded={["a"]}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <span>Xác minh danh tính online</span>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                      Xác định và phòng tránh giả mạo thông qua công nghệ so khớp khuôn mặt, tạo ra một giải pháp định danh trực tuyến toàn diện, an toàn và mang lại trải nghiệm tuyệt vời cho khách hàng.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem uuid="b">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <span>Camera AI</span>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                      Áp dụng thuật toán học sâu và thị giác máy tính trong hệ thống chấm công, theo dõi phương tiện và nhận diện đối tượng dựa trên khuôn mặt.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem uuid="c">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <span>Số hoá tài liệu</span>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                      Sử dụng học sâu và OCR để số hoá tài liệu giấy tờ, chúng tôi giúp tối ưu hóa quy trình, nâng cao hiệu suất và chính xác trong công tác quản lý văn bản.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WhatWeDo
